import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/service/api.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { ModalComponent } from '../modal.component';

@Component({
  selector: 'app-select-stock-gedcom',
  templateUrl: './select-stock-gedcom.component.html',
  styleUrls: ['./select-stock-gedcom.component.scss']
})
export class SelectStockGEDCOMComponent implements OnInit {

  officialGedcom: any = [];

  constructor(
    private profileService: ProfileService,
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private apiService: ApiService
  ) { }
  SelectGedcoms() {
    let stockgedcoms = []
    this.officialGedcom.forEach(gedcom => {
      if (gedcom.selected) {
        this.apiService.postUserOfficialGedcom(gedcom.filename).then((gedcoms: any) => { 
          this.dialogRef.close(true);
        }, err => console.log(err))
      }
    });

  }

  async getOfficialGedcomFiles() {
    this.apiService.getOfficialGedcom().then((gedcoms: any) => {

      gedcoms = JSON.parse(gedcoms)
      gedcoms.forEach(obj => {
        let gedcom = {
          selected: false,
          name: obj.name,
          filename: obj.filename
        }
        let inArray = false;
        this.modalData.forEach(element => {
          if(element.publicGedcom && element.filename == obj.filename){
            inArray = true;
            return
          }
        });
        if(!inArray){
          this.officialGedcom.push(gedcom);
          inArray = false
        }

      });
    }, err => { console.log('error', err) })


  }

  ngOnInit(): void {
    this.getOfficialGedcomFiles();
  }

}
